var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 48,
    height: 48,
    fill: "#0F90FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.8333C10 13.8208 10.8323 13 11.859 13H37.141C38.1677 13 39 13.8208 39 14.8333V33.1667C39 34.1792 38.1677 35 37.141 35H11.859C10.8323 35 10 34.1792 10 33.1667V14.8333ZM13.3462 24V31.7H35.6538V28.4L30.5389 23.3556C29.6678 22.4965 28.2553 22.4965 27.3841 23.3556L26.1731 24.55L27.3814 25.7417C27.8434 26.1973 27.8434 26.936 27.3814 27.3917C26.9194 27.8473 26.1703 27.8473 25.7083 27.3917L19.3851 21.1556C18.5139 20.2965 17.1015 20.2965 16.2303 21.1556L13.3462 24ZM33.4231 20.7C34.6551 20.7 35.6538 19.715 35.6538 18.5C35.6538 17.285 34.6551 16.3 33.4231 16.3C32.1911 16.3 31.1923 17.285 31.1923 18.5C31.1923 19.715 32.1911 20.7 33.4231 20.7Z",
    fill: "#0F90FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictures);
export default __webpack_public_path__ + "static/media/pictures.ba44ad03c8f4290a4ce4f14f0524b020.svg";
export { ForwardRef as ReactComponent };